module.exports = __webpack_public_path__ + "static/media/youtube.bb5f4f98.svg";